import { OrderItemInfo } from 'appTypes/orders'

export const separateOrderItemsFromModule = (
  orderItemsInfo: OrderItemInfo[] | undefined,
): { ordinaryItemsInfo: OrderItemInfo[]; complementaryItemsInfo: OrderItemInfo[] } => {
  const regularOrderItems = orderItemsInfo?.filter((oi) => oi.orderItem.associatedParentOrderItemId === undefined)

  const accessoriesOrderItems = orderItemsInfo?.filter((oi) => oi.orderItem.associatedParentOrderItemId !== undefined)

  return {
    ordinaryItemsInfo: regularOrderItems ?? [],
    complementaryItemsInfo: accessoriesOrderItems ?? [],
  }
}
